import React from 'react';
import styles from '../../lib/global.css';

const Footer = ()=>(
    window.config.isInPad ? null : (
    <React.Fragment>
        {/*
    <div style={{borderTop:'1px solid #d0d0d0', borderBottom:'1px solid #d0d0d0'}}>
        <Row className={styles.pageContentMargin}>
            <Col flex={1}>
                <div className={styles.linksTitle}>关于</div>
                <div><Link className={styles.linksLink} to=''>关于本站</Link></div>
                <div><Link className={styles.linksLink} to=''>关于Scratch</Link></div>
            </Col>
            <Col flex={1}>
                <div className={styles.linksTitle}>关于</div>
                <div><Link className={styles.linksLink} to=''>关于本站</Link></div>
                <div><Link className={styles.linksLink} to=''>关于Scratch</Link></div>
            </Col>
            <Col flex={1}>
                <div className={styles.linksTitle}>关于</div>
                <div><Link className={styles.linksLink} to=''>关于本站</Link></div>
                <div><Link className={styles.linksLink} to=''>关于Scratch</Link></div>
            </Col>
            <Col flex={1}>
                <div className={styles.linksTitle}>关于</div>
                <div><Link className={styles.linksLink} to=''>关于本站</Link></div>
                <div><Link className={styles.linksLink} to=''>关于Scratch</Link></div>
            </Col>
            <Col flex={1}>
                <div className={styles.linksTitle}>关于</div>
                <div><Link className={styles.linksLink} to=''>关于本站</Link></div>
                <div><Link className={styles.linksLink} to=''>关于Scratch</Link></div>
            </Col>
        </Row>

    </div>
        */}
    <footer className={styles.antLayoutFooter} style={{ textAlign: 'center' }}>Copyright ©2021 杭州致奥数据科技有限公司版权所有 <a style={{color:"rgba(0, 0, 0, 0.65)"}} href="http://beian.miit.gov.cn" target={'_blank'}>浙ICP备18017880号-5</a></footer>
    </React.Fragment>
    )
)

export default Footer;
